import gsap, { Power1, Power2 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export class AdvancedDiploma {
  constructor() {
    gsap.registerPlugin(ScrollTrigger)

    const adv = document.querySelector('.p-index_advanced-diploma')
    if (!adv) return

    const inner = adv.querySelector('.p-index_advanced-diploma__inner')
    const titleSpans = adv.querySelectorAll('.p-index_advanced-diploma__info__heading .title span')
    const subtitle = adv.querySelector('.p-index_advanced-diploma__info__heading .subtitle')
    const keywords = Array.from(adv.querySelectorAll('.p-index_advanced-diploma__info__keyword'))
    const infoBg = adv.querySelector('.p-index_advanced-diploma__info__bg')
    const careerSection = adv.querySelector('.p-index_advanced-diploma__career')
    const careerTitle = adv.querySelector('.p-index_advanced-diploma__career__title')
    const careerItems = adv.querySelectorAll('.p-index_advanced-diploma__career__type-item')

    const isSP = window.matchMedia('(max-width: 1023px)').matches

    if (isSP) {
      this.initSP({ adv, titleSpans, subtitle, keywords, infoBg, careerSection, careerTitle, careerItems })
      return
    }

    // =====================
    // PC: pin + timeline
    // =====================
    const pinEnd = '+=4000'

    ScrollTrigger.create({
      trigger: '.p-index_advanced-diploma',
      start: 'top top',
      end: pinEnd,
      pin: true,
      pinSpacing: true,
    })

    gsap.set([titleSpans, subtitle], { opacity: 0, y: 40 })
    gsap.set(keywords, { opacity: 0 })
    gsap.set(careerSection, { opacity: 0 })
    gsap.set([careerTitle, careerItems], { opacity: 0, y: 60 })
    gsap.set(adv, {
      paddingInline: window.innerWidth >= 1280 ? 65 : 20,
    })
    gsap.set(inner, {
      height: window.innerWidth >= 1280 ? 'calc(100% - 80px)' : 'calc(100% - 40px)',
    })

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.p-index_advanced-diploma',
        start: 'top top',
        end: pinEnd,
        scrub: 1,
      }
    })

    tl.to(titleSpans, { opacity: 1, y: 0, duration: 0.5, stagger: 0.15, ease: Power2.easeOut }, 0)
    tl.to(subtitle,   { opacity: 1, y: 0, duration: 0.4, ease: Power2.easeOut }, 0.2)

    const shuffledKeywords = [...keywords].sort(() => Math.random() - 0.5)
    gsap.set(shuffledKeywords, { y: 20 })
    shuffledKeywords.forEach((kw, i) => {
      tl.to(kw, { opacity: 1, y: 0, duration: 0.15, ease: Power2.easeOut }, 0.5 + i * 0.06)
    })

    const infoElements = [
      ...Array.from(titleSpans).reverse(),
      subtitle,
      ...shuffledKeywords,
    ]
    infoElements.forEach((el, i) => {
      tl.to(el, { opacity: 0, y: -40, duration: 0.15, ease: Power1.easeIn }, 2.2 + i * 0.04)
    })

    tl.to(infoBg,        { opacity: 0, duration: 0.3, ease: Power1.easeIn }, 2.4)
    tl.to(careerSection, { opacity: 1, duration: 0.1 }, 2.8)
    tl.to(careerTitle,   { opacity: 1, y: 0, duration: 0.3, ease: Power2.easeOut }, 2.9)
    tl.to(careerItems,   { opacity: 1, y: 0, duration: 0.4, stagger: 0.1, ease: Power2.easeOut }, 3.0)
  }

  initSP({ adv, titleSpans, subtitle, keywords, infoBg, careerSection, careerTitle, careerItems }) {
    const info = adv.querySelector('.p-index_advanced-diploma__info')

    gsap.set([titleSpans, subtitle], { opacity: 0, y: 30 })
    gsap.set(keywords, { opacity: 0 })
    gsap.set(careerSection, { opacity: 0 })
    gsap.set([careerTitle, careerItems], { opacity: 0, y: 40 })

    // __info だけpin、careerは通常スクロール
    const pinEnd = '+=1400'

    ScrollTrigger.create({
      trigger: adv,
      start: 'top top',
      end: pinEnd,
      pin: info,
      pinSpacing: false,
      onEnter: () => {
        careerSection.style.paddingTop = `${info.offsetHeight}px`
      }
    })

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: adv,
        start: 'top top',
        end: pinEnd,
        scrub: 1,
      }
    })

    // ① タイトル・サブタイトル
    tl.to([titleSpans, subtitle], {
      opacity: 1, y: 0, duration: 0.5, stagger: 0.15, ease: Power2.easeOut,
    }, 0)

    // ② キーワード 下からフェードイン
    const shuffledKeywords = [...keywords].sort(() => Math.random() - 0.5)
    gsap.set(shuffledKeywords, { y: 20 })
    shuffledKeywords.forEach((kw, i) => {
      tl.to(kw, { opacity: 1, y: 0, duration: 0.15, ease: Power2.easeOut }, 0.4 + i * 0.06)
    })

    // ③ infoをフェードアウト
    const infoElements = [...Array.from(titleSpans).reverse(), subtitle, ...shuffledKeywords]
    infoElements.forEach((el, i) => {
      tl.to(el, { opacity: 0, y: -20, duration: 0.1, ease: Power1.easeIn }, 1.5 + i * 0.03)
    })
    tl.to(infoBg, { opacity: 0, duration: 0.2 }, 1.6)

    // ④ careerフェードイン（pin終了直前）
    tl.to(careerSection, { opacity: 1, duration: 0.2 }, 1.8)
    tl.to([careerTitle, careerItems], {
      opacity: 1, y: 0, duration: 0.3, stagger: 0.08, ease: Power2.easeOut,
    }, 1.9)
  }
}